import { render, staticRenderFns } from "./PageFour.vue?vue&type=template&id=50dae719&scoped=true"
import script from "./PageFour.vue?vue&type=script&lang=js"
export * from "./PageFour.vue?vue&type=script&lang=js"
import style0 from "./PageFour.vue?vue&type=style&index=0&id=50dae719&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dae719",
  null
  
)

export default component.exports